var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

/**
 * Class for manage pending requests.
 * @private
 */
var PromiseController = require('promise-controller');

var promiseFinally = require('promise.prototype.finally');

module.exports = /*#__PURE__*/function () {
  "use strict";

  function Requests() {
    _classCallCheck(this, Requests);

    this._items = new Map();
  }
  /**
   * Creates new request and stores it in the list.
   *
   * @param {String|Number} requestId
   * @param {Function} fn
   * @param {Number} timeout
   * @returns {Promise}
   */


  _createClass(Requests, [{
    key: "create",
    value: function create(requestId, fn, timeout) {
      this._rejectExistingRequest(requestId);

      return this._createNewRequest(requestId, fn, timeout);
    }
  }, {
    key: "resolve",
    value: function resolve(requestId, data) {
      if (requestId && this._items.has(requestId)) {
        this._items.get(requestId).resolve(data);
      }
    }
  }, {
    key: "rejectAll",
    value: function rejectAll(error) {
      this._items.forEach(function (request) {
        return request.isPending ? request.reject(error) : null;
      });
    }
  }, {
    key: "_rejectExistingRequest",
    value: function _rejectExistingRequest(requestId) {
      var existingRequest = this._items.get(requestId);

      if (existingRequest && existingRequest.isPending) {
        existingRequest.reject(new Error("WebSocket request is replaced, id: ".concat(requestId)));
      }
    }
  }, {
    key: "_createNewRequest",
    value: function _createNewRequest(requestId, fn, timeout) {
      var _this = this;

      var request = new PromiseController({
        timeout: timeout,
        timeoutReason: "WebSocket request was rejected by timeout (".concat(timeout, " ms). RequestId: ").concat(requestId)
      });

      this._items.set(requestId, request);

      return promiseFinally(request.call(fn), function () {
        return _this._deleteRequest(requestId, request);
      });
    }
  }, {
    key: "_deleteRequest",
    value: function _deleteRequest(requestId, request) {
      // this check is important when request was replaced
      if (this._items.get(requestId) === request) {
        this._items.delete(requestId);
      }
    }
  }]);

  return Requests;
}();